import { getToken } from "../storage/authStorage";
import { API_BASE_URL } from "../../../config/api";
import type { TcsListResponseDTO, TcsDTO } from "../models/TaxDTOs";
import type { TcsEntity } from "../../domain/entities/TaxEntity";

/**
 * Fetch TCS list with optional search and pagination.
 * GET /api/tax/tcs
 */
export async function fetchTcsList(
  search?: string,
  limit: number = 50,
  offset: number = 0
): Promise<TcsListResponseDTO> {
  const token = getToken();
  if (!token) {
    throw new Error("No authentication token found");
  }

  const params = new URLSearchParams();
  if (search != null && search !== "") params.set("search", search);
  params.set("limit", String(limit));
  params.set("offset", String(offset));
  const query = params.toString();
  const url = `${API_BASE_URL}/api/tax/tcs${query ? `?${query}` : ""}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(`Failed to fetch TCS list: ${response.status} ${message}`);
  }

  return response.json();
}

/**
 * Map TcsDTO (API shape) to TcsEntity (frontend entity for dropdown).
 */
export function mapTcsDTOToEntity(dto: TcsDTO): TcsEntity {
  return {
    id: dto.id,
    tcs_id: dto.tcs_id,
    tcs_tax_name: dto.tax_name,
    tcs_tax_percentage: dto.tax_rate,
    tcs_nature_of_collection: dto.nature_of_collection ?? undefined,
  };
}
